var map = {
	"./images/eddy-travia-200x200.jpg": 1776
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1775;


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors ^.*\/eddy\-travia\-200x200\.jpg$
// module id = 1775
// module chunks = 146